<template>
    <section>
        <div class="sp-title">卖票公司收款审批</div>
        <div class="sp-nav"><span class="sp-nav-item">商务管理</span><span class="sp-nav-item-sple">/</span><span class="sp-nav-item">卖票公司收款审批</span></div>


        <el-form :inline="true" :model="queryForm" class="query-form demo-form-inline">
<!--            <el-form-item label="供应商类型:">-->
<!--                <el-input v-model="queryForm.supplierType" placeholder="供应商类型"  clearable></el-input>-->
<!--            </el-form-item>-->
<!--          <div style="text-align: left;padding: 10px 0;width: 100%">-->
            <el-form-item label="卖票公司:">
              <el-tag
                v-for="(item,index) in companyList"
                :key="index"
                :type="queryForm.contractCompany==item.code?'success':'info'"
                style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;"
                @click="selectType(item)">{{item.value}}</el-tag>
            </el-form-item>
<!--          </div>-->
<!--          <el-form-item>-->
<!--            <el-button @click="onQuery" type="primary" >查询</el-button>-->
<!--          </el-form-item>-->
        </el-form>
        <template>
            <el-table
                    class="el-table-info mytable"
                    :data="tableData"
                    stripe
                    style="width: 100%"
                    :show-overflow-tooltip="true"
                    border
                    v-loading="tableLoading"
                    >
                <el-table-column
                        :formatter="(row, column, cellValue, index) => { return myFmtDateTime(cellValue,'MM/DD')}"
                        prop="shipTime"
                        label="船期"
                        width="100">
                </el-table-column>
                <el-table-column
                    :formatter="publicFmt"
                     prop="voyageNumber"
                     label="航次号"
                     width="120">
                </el-table-column>
                <el-table-column
                    :formatter="publicFmt"
                     prop="shipName"
                     label="船名"
                     width="100">
                </el-table-column>
              <el-table-column
                :formatter="NumFmt"
                prop="totalUnpaid"
                label="未收总额"
                width="100">
              </el-table-column>
                <el-table-column
                        :formatter="NumFmt"
                        prop="billUnpaid"
                        label="开票未收"
                        width="100">
                </el-table-column>
              <el-table-column
                :formatter="NumFmt"
                prop="arrearsAmount"
                label="欠票金额"
                width="100">
              </el-table-column>
                <el-table-column
                        label="操作"
                >
                    <template slot-scope="scope">
                      <div v-if="scope.row.ticketIsApply == null||scope.row.ticketIsApply == 0">
                        <el-button @click="applyVerifyReceive(scope.row)" type="text" size="small" v-if="scope.row.maiIsReceive == 0">收款申请</el-button>
                        <el-button @click="applyVerifyTicket(scope.row)" type="text" size="small" v-if="scope.row.maiIsTicket == 0">开票登记</el-button>
                      </div>
                      <div v-if="scope.row.ticketIsApply == 1">
                        <el-button class="change-color" type="text" size="small" style="cursor:not-allowed;">正在审批中</el-button>
                      </div>
                    </template>
                </el-table-column>
            </el-table>
        </template>

      <work-flow-component ref="processDrawer1" @onCallback="getReceiveSpId" componentsWidth="45%">
        <div slot="beforeFormSlot" style="position: relative;">
          <CompanyReceiveApprove :applyObj="applyObj" ref="CompanyReceiveApprove"></CompanyReceiveApprove>
        </div>
      </work-flow-component>

      <work-flow-component ref="processDrawer2" @onCallback="getTicketSpId" componentsWidth="45%">
        <div slot="beforeFormSlot" style="position: relative;">
          <CompanyTicketApprove :applyObj="applyObj" ref="CompanyTicketApprove"></CompanyTicketApprove>
        </div>
      </work-flow-component>

    </section>
</template>

<script>

import {ERR_OK} from "../jslib/config";
import {getTicketSupplier} from "../api/syssupplier";
import WorkFlowComponent from "../components/workflow/index";
import SimplePanelSelection from "../components/common/simplePanelSelection";
import WorkFlowProcessDrawer from "../components/workflow/process";
import dayjs from "dayjs";
import {getDictionaryList} from "../api/sysdictionary";
import {fmtDictionary} from "../jslib/util";
import {updateTicketApplyStatus} from "../api/shiplinetranspay";
import CompanyReceiveApprove from "../components/approval/CompanyReceiveApprove"
import CompanyTicketApprove from "../components/approval/CompanyTicketApprove"

export default {
    data() {
        return {
            queryForm:{
              contractCompany:30,
            },
            tableData: [],
            applicationForm:{
              sysSupplierId:null,
              ticketPayment:null,
              payment:null,
              remark:null,
              amountPayable:null,
              price:null,
              invoiceNumber:null,
              invoiceCompany:null,
              billUnpaid:null,
              bill:null,
            },
          companyList:[],
          applyObj:{},
          tableLoading:true,
        };
    },
    created() {
    },
    mounted() {
      this.tableLoading = true
      getDictionaryList("cost_type,contract_company").then(res=>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.dictionaryLists = res.map
          for(var i=0;i<this.dictionaryLists['contract_company'].length;i++){
            if(this.dictionaryLists['contract_company'][i].spare3==1){
             this.companyList.push(this.dictionaryLists['contract_company'][i])
            }
          }
          this.onQuery()
        }
      }).finally(()=>{
        this.tableLoading = false
      });
    },
    methods: {
      getReceiveSpId(id){
        console.log('审批成功，实例ID：' + id);
        var querydata = {
          processId:id,
          shipLineId:this.applyObj.shipLineId,
        }
        updateTicketApplyStatus(querydata).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
          }
        }).finally(() =>{
          this.onQuery()
        })
      },
      getTicketSpId(id){
        console.log('审批成功，实例ID：' + id);
        var querydata = {
          processId:id,
          shipLineId:this.applyObj.shipLineId,
        }
        updateTicketApplyStatus(querydata).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
          }
        }).finally(() =>{
          this.onQuery()
        })
      },
      topage(callback){
        this.tableLoading = true
        var querydata = {
          company:this.queryForm.contractCompany
        }
        getTicketSupplier(querydata).then(res=>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.tableData = res.page
          }
        }).finally(()=>{
          if(callback){
            callback()
          }
          this.tableLoading = false
        })
      },
      refresh() {
        // 审批完成后会调用刷新方法
      },
      handlerGlobalParams(globalParams){
        // 这里是右侧划出审批页面并且请求完数据，返回的全局参数，参考 本组件 132～136 行代码
        console.log(globalParams);
      },
      eventPage(e){
        this.topage(e);
      },
      onQuery(){
        this.topage(function () {

        });
      },
      applyVerifyReceive(item){
        this.applyObj = item
        this.$refs.processDrawer1.title = '卖票公司收款审批'
        this.$refs.processDrawer1.drawer = true
        this.$nextTick(function () {
          this.$refs.CompanyReceiveApprove.getData()
        })
        this.$refs.processDrawer1.processCode = "companyReceiveApprove"
        this.$refs.processDrawer1.globalParams = {}
        this.$refs.processDrawer1.briefContent = "收款总金额为："+(item.billUnpaid != null && item.billUnpaid != 0) ? item.billUnpaid:item.totalUnpaid
        this.$refs.processDrawer1.doInit()
      },
      applyVerifyTicket(item){
        this.applyObj = item
        this.$refs.processDrawer2.title = '卖票公司开票审批'
        this.$refs.processDrawer2.drawer = true
        this.$nextTick(function () {
          this.$refs.CompanyTicketApprove.getData()
        })
        this.$refs.processDrawer2.processCode = "companyTicketApprove"
        this.$refs.processDrawer2.globalParams = {}
        this.$refs.processDrawer2.briefContent = "开票总金额为："+(item.arrearsAmount != null && item.arrearsAmount != 0) ? item.arrearsAmount:item.totalUnpaid
        this.$refs.processDrawer2.doInit()
      },
      publicFmt(row,column,cellValue,index){
        var v = '--'
        if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
          v = cellValue
        }
        return v
      },
      typeFmt(row,column,cellValue,index){
        var v = '--'
        if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
          if(cellValue == 1){
            v='上海港'
          } else if(cellValue == 2){
            v='中转公司'
          } else if(cellValue == 3){
            v='丹东港'
          } else if(cellValue == 4){
            v='保险公司'
          } else if(cellValue == 5){
            v='垫料公司'
          } else if(cellValue == 7){
            v='大连湾港'
          } else if(cellValue == 8){
            v='港口费'
          } else if(cellValue == 9){
            v='理货公司'
          } else if(cellValue == 10){
            v='绑扎公司'
          } else if(cellValue == 11){
            v='船东'
          } else if(cellValue == 12){
            v='莆田港'
          } else if(cellValue == 13){
            v='营口港'
          } else if(cellValue == 14){
            v='鞍钢码头港  '
          } else if(cellValue == 15){
            v='驳船公司'
          }
        }
        return v
      },
      myFmtDateTime(cellValue,fmtstr){
        if(cellValue==undefined||cellValue==null||cellValue==''){
          return '--'
        }
        return dayjs(cellValue).format(fmtstr)
      },
      selectType(obj){
        this.queryForm.contractCompany = obj.code
        this.topage(function () {

        })
      },
      NumFmt(row,column,cellValue,index){
        var v = 0
        if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
          v = parseFloat(Math.abs(cellValue).toFixed(2)) && parseFloat(Math.abs(cellValue).toFixed(2)).toString().replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
        }
        return v
      },
      number_format(num) {
        var v = 0
        if(num!=undefined&&num!=null&&num!=''){
          v = parseFloat(Math.abs(num).toFixed(2)) && parseFloat(Math.abs(num).toFixed(2)).toString().replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
        }
        return v
      },
      costTypeFmt(row,column,cellValue,index){
        return fmtDictionary(cellValue,this.dictionaryLists['cost_type']);
      },
    },
    computed: {},
    components: {WorkFlowComponent,SimplePanelSelection,WorkFlowProcessDrawer,CompanyReceiveApprove,CompanyTicketApprove}
}
</script>

<style scoped>
    .query-form{
        text-align: left;
        padding-top: 10px;
    }
    .el-table-info >>> .cell{
        text-align: center;
    }
    .el-table-info >>> th {
        background: #EDF5FF;
    }
    .mytable td  {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
    .mytable td .cell {
        padding-left: 0.1rem;
        padding-right: 0.1rem;
    }
    .el-table-info >>> .warning-cell{
        color: red;
    }
    .el-table-info >>> .success-cell{
        color: #6DD400;
    }
    .myStep >>>.el-step__main{
        margin-top: 10px;
    }
    .myform >>> .el-form-item{
        margin-right: 20px;
      margin-bottom: 10px;
    }
  .change-color{
    color: #F56C6C;
  }
    .el-table-info >>> .colum-class {
      color: #2cb7fd;
    }
    .el-table-info >>> .colum-class-false {
      color: #C0C4CC;
    }
</style>
